export default __webpack_public_path__ + "static/media/img-3.455e6415.png";